import en from './en'
import zhCN from './zh-CN'
 
//导出所有翻译内容
export default {
  en, zhCN
}